module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fb-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/ack#toc1a",
      "id": "toc1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "toc0",
    staticStyle: {
      "margin-top": "1.5em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/introduction#toc2a",
      "id": "toc2"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/ch01#toc3a",
      "id": "toc3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ONE")]), _vm._v(" / Alibi: Portrait of a Con Man")])]), _vm._v(" "), _c('div', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#toc4a",
      "id": "toc4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TWO")]), _vm._v(" / City Cons and Hustles")])]), _vm._v(" "), _c('div', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#toc5a",
      "id": "toc5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THREE")]), _vm._v(" / The Con Crew")])]), _vm._v(" "), _c('div', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#toc6a",
      "id": "toc6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FOUR")]), _vm._v(" / The Con Game as Street Theater")])]), _vm._v(" "), _c('div', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#toc7a",
      "id": "toc7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIVE")]), _vm._v(" / Petty Street Hustles")])]), _vm._v(" "), _c('div', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#toc8a",
      "id": "toc8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SIX")]), _vm._v(" / Canal Street as Venus Flytrap")])]), _vm._v(" "), _c('div', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#toc9a",
      "id": "toc9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SEVEN")]), _vm._v(" / The Numbers Game")])]), _vm._v(" "), _c('div', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#toc10a",
      "id": "toc10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EIGHT")]), _vm._v(" / New York Tenant Hustles")])]), _vm._v(" "), _c('div', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#toc11a",
      "id": "toc11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NINE")]), _vm._v(" / A Drug Hustle: The Crack Game")])]), _vm._v(" "), _c('div', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#toc12a",
      "id": "toc12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TEN")]), _vm._v(" / NYPD and the Finest Cons")])]), _vm._v(" "), _c('div', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#toc13a",
      "id": "toc13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ELEVEN")]), _vm._v(" / Wall Street Cons")])]), _vm._v(" "), _c('div', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/epilogue#toc14a",
      "id": "toc14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/notes#toc15a",
      "id": "toc15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/glossary#toc16a",
      "id": "toc16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography#toc17a",
      "id": "toc17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/index#toc18a",
      "id": "toc18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0